import { SafeBaseObject } from "@app/core/models/base-object.models"

export class ResGoodwillRMTypes extends SafeBaseObject {
    RMPackageID = 0;
    RMPackageName = '';
    RMPackageShortName = '';

    constructor(data?: any) {
        super();
        this.updateData(data);
        this.addProperty('RMPackageID', data, 'RMPackageID');
        this.addProperty('RMPackageName', data, 'RMPackageName');
        this.addProperty('RMPackageShortName', data, 'RMPackageShortName');
    }
}

export class ResGoodwillDefaultPrices extends SafeBaseObject {
    companyID = 0;
    currencyCod = '';
    sellingPrice = 0;
    voyageID = 0;

    constructor(data?: any) {
        super();
        this.updateData(data);
    }
}

export class ResGoodwillDefaultPriceType extends SafeBaseObject {
    priceTypeID = 0;
    priceTypeName = '';
    companyID = 0;

    constructor(data?: any) {
        super();
        this.updateData(data);
    }
}

export class ResGoodwillCompany extends SafeBaseObject {
    companyID = 0;
    company = '';

    constructor(data?: any) {
        super();
        this.updateData(data);
    }
}

